import type { TFunction } from 'i18next';
import type { FieldError } from '@src/validation/validateField';

function i18nKey(transKey: string): string {
  const name = transKey.startsWith('validations.') ? transKey.slice('validations.'.length) : transKey;
  return `validation.${name}`;
}

/** Map a Yup locale object onto `validation.*` in en.json / ru.json. */
export function translateFieldError(error: FieldError, t: TFunction): string {
  const key = i18nKey(error.transKey);
  const translated = t(key, { field: error.field, ...error.params });
  if (translated === key) {
    return t('validation.invalid');
  }
  return translated;
}
